import Vue from 'vue'
import Vuex from 'vuex'
import axios from './request';
import router from './router';

Vue.use(Vuex);



export default new Vuex.Store({
  state: {
    token: null,
    tournaments: null,
    tournament: null,

    loginFailed: false,
    loginInProgress: true
  },

  mutations: {
    clearLoginState(state) {
      state.loginFailed = false;
      state.loginInProgress = false;
      state.token = null;
    },

    setToken(state, token) {
      state.token = token;
      state.loginInProgress = false;
    },

    setLoginFailed(state) {
      state.loginFailed = true;
      state.loginInProgress = false;
      state.token = null;
      state.tournaments = null;
    },

    setTournaments(state, tournaments) {
      state.tournaments = tournaments;
    },

    setTournament(state, tournament) {
      state.tournament = tournament;
    },


  },
  actions: {
    autoLogin({commit}) {
      if (localStorage.getItem('token')) {
        let token = localStorage.getItem('token');
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;

        axios.get('/api/tournaments')
          .then(function (response) {
            commit('setToken', token);
            commit('setTournaments', response.data);
          })
          .catch(function () {
            localStorage.removeItem('token');

            commit('setToken', null);
            commit('setTournaments', null);
          });
      } else {

        commit('setToken', null);
        commit('setTournaments', null);
      }
    },


    authenticate({commit}, {username, password}) {

      commit('clearLoginState');

      axios.post('/api/auth', {email: username, password: password})
        .then(function (response) {

          let token = response.data.token;
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;

          return axios.get('/api/tournaments')
            .then(function (response) {
              commit('setToken', token);
              commit('setTournaments', response.data);

              localStorage.setItem('token', token);
              router.push('/tournaments');
            })

        })
        .catch(function () {

          commit('setLoginFailed');
        });
    },


    logout({commit}) {

      commit('clearLoginState');
      commit('setTournaments', null);

      if (localStorage.getItem('token')) {
        localStorage.removeItem('token');
      }

      axios.defaults.headers.common['Authorization'] = null;

      router.push('/auth/login');
    },



    tournamentChanged({commit, state}, tournament) {

      let existingTournament = state.tournaments.filter(t => t.id == tournament.id);

      if (existingTournament && existingTournament.length > 0) {
        existingTournament = existingTournament[0];
        Object.assign(existingTournament, tournament);
      } else {
        existingTournament = undefined;
      }

      commit('setTournaments', (existingTournament ? [...state.tournaments] : [...state.tournaments, tournament]));
      router.push('/tournaments');
    },


    loadTournament({commit}, id) {

      commit('setTournament', null);

      axios.get('/api/tournament/' + id)
          .then(function (response) {
            commit('setTournament', response.data);
          });
    },


    updateTournament({commit, state}, id) {

      axios.get('/api/tournament/' + id)
          .then(function (response) {

            if (state && JSON.stringify(state.tournament) === JSON.stringify(response.data)) {
              return /* nothing to update */;
            }

            commit('setTournament', response.data);
          });
    },


    checkTournamentLoaded({commit, state}, id) {

      if (!state || !state.tournament || state.tournament.id != id) {
        commit('setTournament', null);

        axios.get('/api/tournament/' + id)
            .then(function (response) {
              commit('setTournament', response.data);
            });
      }
    },


    deleteItem({ commit, state }, { type, item }) {

      axios.delete('/api/' + type + '/' + item.id)

          .then(function(){
            switch(type) {
              case 'tournament': {
                commit('setTournaments', [...state.tournaments.filter(t => (t.id != item.id))]);
                router.push('/tournaments');
                break;
              }

              case 'event': {
                let tournament = state.tournament;
                tournament.events = [...tournament.events.filter(e => (e.id != item.id))];
                commit('setTournament', tournament);
                router.push('/tournaments/' + tournament.id + '/events');
                break;
              }

              case 'team': {
                let tournament = state.tournament;
                tournament.teams = [...tournament.teams.filter(t => (t.id != item.id))];
                commit('setTournament', tournament);
                router.push('/tournaments/' + tournament.id + '/teams');
                break;
              }

              case 'draw': {
                let tournament = state.tournament;
                let event = [...tournament.events.filter(e => e.id == item.tournamentEventId)];

                if (event && event.length > 0) {
                  event = event[0];

                  axios.get('/api/tournament/' + tournament.id)
                      .then(function (response) {
                        commit('setTournament', response.data);
                      })
                      .then(function(){
                        router.push('/tournaments/' + tournament.id + '/events/' + event.id + '/draws');
                      });
                }

                break;
              }


              case 'entry': {
                let tournament = state.tournament;
                let event = [...tournament.events.filter(e => e.id == item.tournamentEventId)];

                if (event && event.length > 0) {
                  event = event[0];
                  event.entries = event.entries.filter(e => (e.id != item.id));

                  router.push('/tournaments/' + tournament.id + '/events/' + event.id + '/entries');
                }

                break;
              }
            }
          })
          .catch(function(){});
    },



    clearDraws({ commit, state }, { id }) {

      axios.delete('/api/tournament-draws/' + id)
          .then(function(){

            axios.get('/api/tournament/' + id)
                .then(function (response) {
                  commit('setTournament', response.data);
                })
                .then(function(){
                  router.push('/tournaments/' + id + '/matches');
                });
          })
          .catch(function(){});
    },


    tournamentTeamsChanged({ commit, state }, { tournamentId, teams }) {
      let storeTournament = state.tournament;

      if (storeTournament && storeTournament.id == tournamentId) {
        storeTournament.teams = teams;
        commit('setTournament', storeTournament);

        router.push('/tournaments/' + tournamentId + '/teams');
      }

    },


    tournamentEventsChanged({ commit, state }, { tournamentId, events, suggestedPage, stayOnPage }) {
      let storeTournament = state.tournament;

      if (storeTournament && storeTournament.id == tournamentId) {
        storeTournament.events = events;
        commit('setTournament', storeTournament);

        if (!stayOnPage)
          router.push(suggestedPage ? suggestedPage : ('/tournaments/' + tournamentId + '/events'));
      }

    }
  }
})
